import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ArtDirection = makeShortcode("ArtDirection");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`ArtefactCard`}</h1>
    <PageDescription mdxType="PageDescription">
      <p>{`Nutze ArtefactCard um Artefakten, Gemälde, Archivalien und sonstige digitale Kunstwerke in Kachelform darzustellen.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Überblick</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Live Demo</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Formartierung</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Referenzen</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Überblick`}</h2>
    <p>{`ArtefactCard visualisiert digitale Kunstwerke in Kachelform mit den ersten notwendigen Daten.`}</p>
    <h4>{`Wann zu verwenden`}</h4>
    <p>{`ArtefactCard ist für die Listung eines digitalen Kunstwerkes zu verwenden.`}</p>
    <h2>{`Formatierung`}</h2>
    <h3>{`Anatomy`}</h3>
    <ArtDirection mdxType="ArtDirection">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "773px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "87.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAASABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAEFAgME/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGy1OPNuxqYAgH/xAAcEAABAwUAAAAAAAAAAAAAAAABAgMTAAQRIDH/2gAIAQEAAQUCfWUmVUlXfGzl3T//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgEFAAAAAAAAAAAAAAABAgAxERASICEi/9oACAEBAAY/Ak2mzEGeidFu4nkjB4//xAAbEAADAAMBAQAAAAAAAAAAAAAAAREhMVFhcf/aAAgBAQABPyFPQonjwugjheNjFrY0bXwgUlXKNwr6V9Y2+n//2gAMAwEAAgADAAAAEIsAAP/EABYRAAMAAAAAAAAAAAAAAAAAABEgIf/aAAgBAwEBPxCBP//EABcRAAMBAAAAAAAAAAAAAAAAAAERIDH/2gAIAQIBAT8QZ2P/xAAfEAEAAgIBBQEAAAAAAAAAAAABABEhMYFBUWFxkfH/2gAIAQEAAT8QCZnEOLJAzSNXCl41Nz1EGJqd3SMAA6QKcXzFou5c8z7P3Je2+z//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ArtefactCard anatomy",
          "title": "ArtefactCard anatomy",
          "src": "/static/1fbc2510101f8ce72135b843c3a4c73c/c303a/artefactCard-anatomy.jpg",
          "srcSet": ["/static/1fbc2510101f8ce72135b843c3a4c73c/69549/artefactCard-anatomy.jpg 288w", "/static/1fbc2510101f8ce72135b843c3a4c73c/473e3/artefactCard-anatomy.jpg 576w", "/static/1fbc2510101f8ce72135b843c3a4c73c/c303a/artefactCard-anatomy.jpg 773w"],
          "sizes": "(max-width: 773px) 100vw, 773px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ArtDirection>
    <p>{`The modal is composed of three distinct zones: A header, the body, and a footer.
Components (eg. data table, form, progress indicator) can occupy the full width
of the modal.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Bildbereich`}</strong>{`: Enthält das Bild des digitalen Kunswerkes`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Inhaltsbereich`}</strong>{`: Enthält den Titel, Subtitel und die Klassifikation des digitalen Kunstwerkes`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Titel`}</strong>{`: Gibt die Hauptbezeichnung des digitalen Kunstwerkes`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Klassifikation`}</strong>{`: Die Klassifikation des Kunstwerkes`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Subtitel`}</strong>{`: Beschreibt den Untertitel`}</p>
      </li>
    </ol>
    <h2>{`Code`}</h2>
    <h3>{`Dokumentation`}</h3>
    <p>{`Das folgende Storybook zeigt ArtefactCard in einer Live Demo. Des Weiteren kann in dieser Testumgebung der Button mit verschiedenen Props und Variante getestet werden.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="React Dokumentation" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app/?path=/story/molecules-artefactcard--template" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Code`}</h3>
    <p>{`ArtefactCard mit Standardwerten`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<ArtefactCard />

`}</code></pre>
    <p>{`Beispiel: ArtefactCard mit der Übergabe aller möglichen props`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<ArtefactCard
  title={'Martin Luther als „Junker Jörg“'}
  subtitle={'Lucas Cranach der Ältere'}
  date={'1829'}
  classification={'Druckgrafik'}
  imgSrc={'https://lucascranach.org/application/files/5715/2205/3270/Martin-Luther-als-Junker-Joerg.jpg'}
  imgAlt={'lucas cranach image'}
/>

`}</code></pre>
    <h4>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Optionen`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Doppelbildnis Friedrich der Weise`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Haupttitel von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`subtitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Lucas Cranach der Ältere`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Subtitel von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1877`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Datum von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`classification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Druckgrafik`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Klassifikation von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`imgSrc`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://lucascranach.org/application/files/1715/2120/9916/Portraet001.jpg"
            }}>{`https://lucascranach.org/application/files/1715/2120/9916/Portraet001.jpg`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bild von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`imgAlt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cranach Image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alternativer Bildtext von des digitalen Kunstwerks`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Referenzen`}</h2>
    <p>{`Siehe `}<a parentName="p" {...{
        "href": "https://lucascranach.org/graphics/de"
      }}>{`Beispiel`}</a></p>
    <h2>{`Feedback`}</h2>
    <p>{`Helfe uns um diese Komponente/Pattern zu verbessern, indem sie Feedback geben, fragen stelle oder andere Kommentare auf `}<a parentName="p" {...{
        "href": "https://github.com/cranach-design-system/cranach-design/issues/new?assignees=&labels=&template=website-feedback.md&title=Website+feedback"
      }}>{`Github`}</a>{` hinterlassen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      